
export default "/assets/bars-arrow-up-micro.e1f2e26f.svg"